const ReceiptAdd = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-receipt-add"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-receipt-add"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path
        d="M19.42 11.75H16C15.59 11.75 15.25 11.41 15.25 11V4.01C15.25 3.27 15.54 2.58 16.06 2.06C16.58 1.54 17.27 1.25 18.01 1.25H18.02C19.27 1.26 20.45 1.75 21.35 2.64C22.25 3.55 22.74 4.75 22.74 6V8.42C22.75 10.41 21.41 11.75 19.42 11.75ZM16.75 10.25H19.42C20.58 10.25 21.25 9.58 21.25 8.42V6C21.25 5.14 20.91 4.32 20.3 3.7C19.69 3.1 18.87 2.76 18.02 2.75C18.02 2.75 18.02 2.75 18.01 2.75C17.68 2.75 17.36 2.88 17.12 3.12C16.88 3.36 16.75 3.67 16.75 4.01V10.25Z"
        fill="currentColor"
      />
      <path
        d="M8.99977 23.33C8.52977 23.35 8.08977 23.15 7.75977 22.81L6.09978 21.14C6.00978 21.05 5.86978 21.04 5.76978 21.12L4.05977 22.4C3.52977 22.8 2.82977 22.87 2.22977 22.57C1.62977 22.27 1.25977 21.67 1.25977 21V6C1.25977 2.98 2.98977 1.25 6.00977 1.25H18.0098C18.4198 1.25 18.7598 1.59 18.7598 2C18.7598 2.41 18.4198 2.75 18.0098 2.75C17.3198 2.75 16.7598 3.31 16.7598 4V21C16.7598 21.67 16.3898 22.27 15.7898 22.57C15.1898 22.87 14.4898 22.81 13.9598 22.41L12.2498 21.13C12.1498 21.05 12.0098 21.07 11.9298 21.15L10.2498 22.83C9.90977 23.15 9.46977 23.33 8.99977 23.33ZM5.90977 19.57C6.36977 19.57 6.81977 19.74 7.15977 20.09L8.81978 21.76C8.87978 21.82 8.95977 21.83 8.99977 21.83C8.99977 21.81 9.11976 21.82 9.17976 21.76L10.8598 20.08C11.4798 19.46 12.4598 19.4 13.1498 19.93L14.8498 21.2C14.9598 21.28 15.0598 21.25 15.1098 21.22C15.1598 21.19 15.2498 21.13 15.2498 21V4C15.2498 3.55 15.3598 3.12 15.5498 2.75H5.99977C3.77977 2.75 2.74977 3.78 2.74977 6V21C2.74977 21.14 2.83977 21.2 2.88977 21.23C2.94977 21.26 3.04976 21.28 3.14977 21.2L4.85977 19.92C5.16977 19.69 5.53977 19.57 5.90977 19.57Z"
        fill="currentColor"
      />
      <path
        d="M11.75 10.75H6.25C5.84 10.75 5.5 10.41 5.5 10C5.5 9.59 5.84 9.25 6.25 9.25H11.75C12.16 9.25 12.5 9.59 12.5 10C12.5 10.41 12.16 10.75 11.75 10.75Z"
        fill="currentColor"
      />
      <path
        d="M9 13.5C8.59 13.5 8.25 13.16 8.25 12.75V7.25C8.25 6.84 8.59 6.5 9 6.5C9.41 6.5 9.75 6.84 9.75 7.25V12.75C9.75 13.16 9.41 13.5 9 13.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ReceiptAdd;
